export class TrafficSystemSettings {
  id!: string
  active!: boolean
  trafficSystem!: any
  customProperties?: any
}
